/**
* @author vishwadeep.kapoor
* SearchResult
*
*/

import React, { PureComponent } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { shape, string, func, bool } from 'prop-types';

import { utils, constants, eventTracking } from '../../devUtils';
import { getSearchType, selectUserDetails } from '../HeaderContainer/selectors';
import { changeSearchBox } from '../RestaurantDeals/actions';
import RestaurantsList from '../RestaurantsList/Loadable';
import { DEFAULT_GIFTCARD_PAYLOAD, DEFAULT_GIFTCARD_CLIENT, VALIDATE_MERCHANDISE } from '../GiftCardsList/constants';
import { DEFAULT_REDEEMGIFTCARD_PAYLOAD } from '../RedeemZsc/constants';
import GiftCard from '../GiftCard/index';
import { fetchGiftCardList } from '../GiftCardsList/actions';
import { getGiftCardClientId } from '../GiftCardsList/selectors';

class SearchResult extends PureComponent {
  constructor(props) {
    super(props);
    const { history: { location: { search } }, history } = props;
    this.stateLessKeys = { history, type: '', value: utils.parseQueryString(search).s, giftCardPayload: {} };
  }

  /**
   * @todo on refresh search again
   */
  componentWillMount() {
    this.setSearchResult(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { getSearchParams } = nextProps;
    const { getSearchParams: _getSearchParams } = this.props;
    if (!utils.isEqual(_getSearchParams, getSearchParams)) {
      this.setSearchResult(nextProps);
    }
  }

  setSearchResult({ getSearchParams: { type = '', value = '' } = {} }) {
    const { value: svalue, history: { location: { state: { prePath } = {} }, pathname } } = this.stateLessKeys;
    const { giftcardClientId, onGetGiftCardList, onRestroSearchChange, GetUserDetails } = this.props;
    this.stateLessKeys.type = (prePath === constants.LINK_REDEEM_ZSC || (giftcardClientId && giftcardClientId !== DEFAULT_GIFTCARD_CLIENT)) ? 'zscCard' : type;
    const searchValue = value || svalue;
    const labelName = `<${pathname}>---<${searchValue}>`;
    if (this.stateLessKeys.type === 'resturants') {
      eventTracking.triggerEvent('Restaurant Deals', 'Header Search', labelName);
      onRestroSearchChange(searchValue);
    } else if (this.stateLessKeys.type === 'zscCard' && giftcardClientId && giftcardClientId !== DEFAULT_GIFTCARD_CLIENT) {
      const param = { name: searchValue, client_ids: giftcardClientId };
      let payload = { ...DEFAULT_REDEEMGIFTCARD_PAYLOAD, ...param };
      eventTracking.triggerEvent('Redeem ZSC', 'Header Search', labelName);
      payload = VALIDATE_MERCHANDISE(payload, GetUserDetails);
      onGetGiftCardList(payload);
    } else if (['giftCards', 'zscCard'].indexOf(this.stateLessKeys.type) !== -1) {
      const param = { name: searchValue };
      let payload = { ...DEFAULT_GIFTCARD_PAYLOAD, ...param };
      eventTracking.triggerEvent('Gift Cards', 'Header Search', labelName);
      payload = VALIDATE_MERCHANDISE(payload, GetUserDetails);
      onGetGiftCardList(payload);
    }
  }

  /**
   * @desc resturants link iss been removed from the select option
   */
  render() {
    const { history, type } = this.stateLessKeys;
    const { giftcardClientId, GetUserDetails: { isOnlyMerchandise = false, client_id } } = this.props;
    switch (type) {
      case 'resturants':
        return <RestaurantsList.component history={history} />;
      case 'giftCards':
        return <GiftCard history={history} client_id={isOnlyMerchandise ? client_id : DEFAULT_GIFTCARD_CLIENT} />;
      case 'zscCard':
        return <GiftCard history={history} client_id={giftcardClientId} />;
      default:
        return (
          <div>
            Select Search type
          </div>
        );
    }
  }
}

SearchResult.propTypes = {
  giftcardClientId: string.isRequired,
  history: shape({}).isRequired,
  getSearchParams: shape({}).isRequired,
  onRestroSearchChange: func.isRequired,
  onGetGiftCardList: func.isRequired,
  GetUserDetails: shape({
    isOnlyMerchandise: bool,
    client_id: string,
  }).isRequired,
};


const mapDispatchToProps = (dispatch) => ({
  onRestroSearchChange: (value) => dispatch(changeSearchBox(value)),
  onGetGiftCardList: (payload) => dispatch(fetchGiftCardList(payload)),
});

const mapStateToProps = createStructuredSelector({
  getSearchParams: getSearchType(),
  giftcardClientId: getGiftCardClientId(),
  GetUserDetails: selectUserDetails(),
});

const component = connect(mapStateToProps, mapDispatchToProps)(SearchResult);
export { mapDispatchToProps, mapStateToProps, SearchResult };
export default component;



// WEBPACK FOOTER //
// client/containers/SearchResult/index.js